<template>
    <ul class="search-results__spots">

        <li class="no-results" v-if="!spots.length">No Results</li>

        <li v-for="(spot, index) in spots" :key="`spot-${index}`" class="search-place">

            <a :href="`/${spot.city.slug}/${spot.slug}`" class='img-wrap'>
                <img :src="spot.image" v-rjs="2">
            </a>

            <div class="content">
                <h3 :class="`cat-${spot.category.slug}`">
                    <a :href="`/destination/${spot.city.slug}/browse?category=${spot.category.slug}`">
                        {{ spot.category.title }} <span>in</span> {{ spot.city.title }}
                    </a>
                </h3>

                <h2>
                    <a :href="`/${spot.city.slug}/${spot.slug}`" v-text="spot.name"></a>
                </h2>

                <span v-if="spot.category.slug !== 'sleep'">
                    <a href='`/destination/${spot.city.slug}/`'>
                        {{ spot.subcategory ? spot.subcategory.title : '' }}
                    </a>
                </span>

                <span v-else-if="spot.neighborhood">
                    <a :href='`/destination/${spot.city.slug}/browse?neighborhoods`'>
                        {{ spot.neighborhood.title }}
                    </a>
                </span>

            </div>
        </li>
    </ul>
</template>

<script>

export default {

    props: ['data', 'limit'],

    data() {
        return {
            spots: this.limit ? _.take(this.data, this.limit) : this.data
        }
    },

    watch:{
        data(){
            this.spots = this.limit ? _.take(this.data, this.limit) : this.data
        }
    }
}
</script>